export const trackEvent = (category, action, label) => {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      debug_mode: true,
    });
    // console.log(`Evento enviado: Donación con ${label}`);
  } else {
    console.error("gtag no está definido");
  }
};
